
// Dynamic Components for the templates
/**
 * Changing the reference to "/node_modules/<package>"
 * Gives us the ability to use packages install in the root "node_modules"
 * This has the following effects
 * - Fixes the vue-style-loader issue caused by nested packages
 * - Allows for projects to use specific versions for the packages
 *
 * ASSUMES
 * The packages are already installed by the target project
 */

export default {
  name: 'DynamicComponent',
  props: {
    node: {
      type: Object,
      default: () => ({
        component: '',
        children: [],
        props: {},
        attrs: {},
      }),
    },
  },
}
